<template>
	<transition name="fade" mode="out-in">
		<div
			v-if="showAlertMessage"
			v-show="open"
			:class="`b360-alert--${alertClass}`"
			id="response-alert"
		>
			<font-awesome-icon
				:icon="['far', 'times-circle']"
				@click="close"
				v-if="!hideClose"
			/>
			<p id="response-alert-message">{{ alertMessage }}</p>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'AlertMessage',
	props: {
		showAlertMessage: Boolean,
		alertClass: String,
		alertMessage: String,
		hideClose: Boolean,
	},
	data() {
		return {
			closed: false,
		};
	},
	methods: {
		close() {
			this.$emit('handle-close');
			this.closed = true;
		},
	},
	computed: {
		open() {
			return !this.closed;
		},
	},
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

#response-alert {
	&.b360-alert--success,
	&.b360-alert--error {
		@include rem(padding, 10px);
		@include rem(margin, 30px 0);

		p,
		svg {
			@include typo--roboto__medium;
			margin-bottom: 0;
		}

		p {
			text-align: center;
		}

		svg {
			float: right;
			@include rem('font-size', 20px);
			cursor: pointer;
		}
	}

	&.b360-alert--success {
		background-color: rgba($success, 0.1);
		border-bottom: 1px solid $success;

		p,
		svg {
			color: $success;
		}
	}

	&.b360-alert--error {
		background-color: rgba($error, 0.1);
		border-bottom: 1px solid $error;

		p,
		svg {
			color: $error;
		}
	}
}
</style>
